var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47739 4.467C9.77176 4.75841 9.77416 5.23328 9.48275 5.52765L5.79781 9.24999L16 9.25001C16.4142 9.25001 16.75 9.5858 16.75 10C16.75 10.4142 16.4142 10.75 16 10.75L5.79781 10.75L9.48275 14.4724C9.77416 14.7667 9.77176 15.2416 9.47739 15.533C9.18302 15.8244 8.70816 15.822 8.41675 15.5276L3.467 10.5276C3.17767 10.2354 3.17767 9.76461 3.467 9.47234L8.41675 4.47235C8.70816 4.17799 9.18302 4.17559 9.47739 4.467Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "6ac0095704dbdaa0bf08eaaa0663153d.svg";
export { ForwardRef as ReactComponent };